function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "expo-image";
import { createContext, useContext } from "react";
import AvivaAvatar from "../assets/chat_avatar.svg";
import { useTheme } from "../styles";
var botAvatar = /*#__PURE__*/ _jsx(Image, {
    source: AvivaAvatar,
    style: {
        width: 40,
        height: 40
    }
});
var ConversationContext = /*#__PURE__*/ createContext({
    botName: 'Aviva',
    botAvatar: botAvatar,
    receivedMessageBorderColor: 'black',
    sentMessageBackgroundColor: '#eee',
    showTabsAfterCompletion: false,
    showTabsBeforeCompletion: false,
    accentColor: 'black'
});
/**
 * Allows theming / configuration the Conversation/Chatbot UI.
 *
 * Options:
 *
 * - botName
 * - botAvatar
 * - receivedMessageBorderColor
 * - sentMessageBackgroundColor
 * - showTabsAfterCompletion
 * - showTabsBeforeCompletion
 * - accentColor
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-14}
 */ export function ConversationProvider(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(ConversationContext.Provider, {
        value: _object_spread({
            botName: 'Aviva',
            botAvatar: botAvatar,
            receivedMessageBorderColor: theme.color.gray700,
            sentMessageBackgroundColor: theme.color.accentTwo100,
            showTabsAfterCompletion: false,
            showTabsBeforeCompletion: false,
            accentColor: theme.color.accent100
        }, props),
        children: children
    });
}
/**
 * Allows theming / configuration the Conversation/Chatbot UI.
 *
 * Options:
 *
 * - botName
 * - botAvatar
 * - receivedMessageBorderColor
 * - sentMessageBackgroundColor
 * - showTabsAfterCompletion
 * - showTabsBeforeCompletion
 * - accentColor
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-14}
 */ export function useConversationContext() {
    return useContext(ConversationContext);
}
